import React from "react";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";

const Header = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;

  return (
    <section
      className="py-xxl-10 pb-0"
      id="home"
      style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
    >
      <div
        className="bg-holder"
        style={{
          backgroundImage: `url(${heroBgImage})`,
          backgroundPosition: "bottom",
          backgroundSize: "cover",

          //   height: "100vh", // Add a height to ensure background is visible
        }}
      />

      <div className="container-header">
        <div
          className="row min-vh-xl-100 min-vh-xxl-25  "
          style={{ display: "flex", justifyContent: "center", marginTop:"30px" }}
        >
          <div className="  text-center paddin-header-home" style={{ width: "70%" }}>
            <h2 className="">
              <span
                className=" general-tittle-mbl "
                style={{
                  fontSize: "38px",
                  fontFamily: "Raleway, sanf-serif",
                  color: "#fff",
                  paddingBottom: " 10px",
                }}
              >
                Look after your skin. You will wear it every day for the rest of
                your life.
              </span>
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
